import React from 'react'

export const TeaserOfferSkeleton: React.FC = () => (
  <div className="relative flex flex-col overflow-hidden shadow-xl animate-pulse lg:h-36 lg:flex-row rounded-xl">
    <div className="object-cover w-full overflow-hidden bg-gray-200 h-36 lg:h-full lg:w-72" />
    <div className="absolute flex flex-col items-center justify-center w-24 h-24 p-2 transform -translate-x-1/2 bg-white shadow top-16 left-1/2 lg:left-56 lg:top-6 lg:translate-x-0 rounded-xl">
      <div />
    </div>
    <div className="flex flex-col gap-1 p-6 lg:ml-8 grow">
      <div className="w-56 py-4 mr-2 bg-gray-200 lg:w-96 rounded-xl" />
      <div className="py-4 mb-3 bg-gray-200 md:w-3/4 rounded-xl " />
      <div className="flex flex-wrap gap-4 justify-wrap ">
        <div className="flex flex-row gap-1 p-4 bg-gray-200 rounded-xl" />
        <div className="flex flex-row gap-1 p-4 bg-gray-200 rounded-xl" />
        <div className="flex flex-row gap-1 p-4 bg-gray-200 rounded-xl" />
      </div>
    </div>
    <div className="absolute px-12 py-4 bg-gray-200 rounded-md right-6 top-6 max-lg:hidden" />
  </div>
)
